import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import './ArtGamesHero.css';

export default function ArtGamesHero({ title, backLabel, backRoute }) {
  return (
    <header className="art-games-hero" aria-labelledby="art-games-hero-title">
      <GoBackButton
        alternativeRoute={backRoute}
        label={backLabel}
        className="art-games-hero__back"
      />

      <div className="art-games-hero__layout">
        <div className="art-games-hero__copy">
          <h1 id="art-games-hero-title" className="art-games-hero__title">{title}</h1>
        </div>
      </div>
    </header>
  );
}
